import * as THREE from 'three';
import TWEEN from 'three/addons/libs/tween.module.js';
import { prefersReducedMotion } from '../utils/motion-preference';

const HIDE_DURATION_MS = 700;

export default class LoadingOverlay extends THREE.Group {
  private overlayMaterial: THREE.ShaderMaterial;

  constructor() {
    super();

    this.init();
  }

  public hide(): void {
    const duration = prefersReducedMotion() ? 0 : HIDE_DURATION_MS;

    new TWEEN.Tween(this.overlayMaterial.uniforms.uAlpha)
      .to({ value: 0 }, duration)
      .easing(TWEEN.Easing.Cubic.Out)
      .start()
      .onComplete(() => {
        this.visible = false;
      });
  }

  private init(): void {
    const overlayGeometry = new THREE.PlaneGeometry(2, 2, 1, 1);
    const overlayMaterial = this.overlayMaterial = new THREE.ShaderMaterial({
      transparent: true,
      uniforms: {
        uAlpha: { value: 1 },
      },
      vertexShader: `
        void main()
        {
          gl_Position = vec4(position, 0.5);
        }
      `,
      fragmentShader: `
        uniform float uAlpha;

        void main()
        {
          gl_FragColor = vec4(0.9922, 0.9882, 0.9765, uAlpha);
        }
      `,
    });

    const overlay = new THREE.Mesh(overlayGeometry, overlayMaterial);
    this.add(overlay);
  }
}
